// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e10e4b6d","732":"0f0b12de","977":"6110303a"}[chunkId] + ".chunk.js";
};